var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading grey--text text--darken-1 px-5"},[_c('v-progress-circular',{staticClass:"mx-auto mt-5 mb-3",attrs:{"indeterminate":"","color":"primary"}}),_vm._v("\n    "+_vm._s(_vm.$t(_vm.statusKey))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }